const page404 = {
  page404: {
    startTyping: "Where do you want to go?",
    linkToMainText: "To the main page",
    linkToSearchText: "Find a Journey",
  },
};

export { page404 };
